import axios from "axios";

export default {
  namespaced: true,

  state: () => ({
    suppliers: {}, // key: supplierId, value: supplier object
    loading: false,
    error: null,
  }),

  getters: {
    getSupplierById: (state) => (supplierId) => state.suppliers?.[supplierId] || null,
    allSuppliers: (state) => Object.values(state.suppliers || {}),
  },

  mutations: {
    setSupplier(state, { supplierId, supplier }) {
      if (!supplierId || !supplier) return;
      state.suppliers = { ...state.suppliers, [supplierId]: { ...supplier } };
    },

    updateSupplier(state, { supplierId, updates }) {
      if (!supplierId || !updates) return;
      const existing = state.suppliers?.[supplierId] || {};
      state.suppliers = { ...state.suppliers, [supplierId]: { ...existing, ...updates } };
    },

    removeSupplier(state, supplierId) {
      if (!supplierId || !state.suppliers[supplierId]) return;
      const { [supplierId]: removed, ...rest } = state.suppliers;
      state.suppliers = rest;
    },

    setLoading(state, loading = false) {
      state.loading = !!loading;
    },

    setError(state, error = null) {
      state.error = error || null;
    },
  },

  actions: {
    // Fetch all suppliers
    async fetchSuppliers({ commit }) {
      commit("setLoading", true);
      commit("setError", null);

      try {
        const response = await axios.get("/api/suppliers");
        const suppliers = response.data || [];
        // Reset state
        commit("setLoading", true);
        Object.keys(this.suppliers || {}).forEach(id => commit("removeSupplier", id));
        suppliers.forEach((supplier) => {
          commit("setSupplier", { supplierId: supplier.id, supplier });
        });
        return suppliers; // ✅ return for then()
      } catch (err) {
        const message = err?.response?.data?.message || err.message || "Failed to fetch suppliers";
        commit("setError", message);
        throw new Error(message);
      } finally {
        commit("setLoading", false);
      }
    },

 async fetchSupplier({ commit }, supplierId) {
  if (!supplierId) return null;

  commit("setLoading", true);
  commit("setError", null);

  try {
    const response = await axios.get(`/api/suppliers/${supplierId}`);
    const supplierData = response.data?.supplier || null;

    // Save supplier in Vuex
    commit("setSupplier", { supplierId, supplier: supplierData });

    // Return full API response for component to access transactions, shipments, analysis
    return response.data;
  } catch (err) {
    const message = err?.response?.data?.message || err.message || "Failed to fetch supplier";
    commit("setError", message);
    commit("setSupplier", { supplierId, supplier: null });
    throw new Error(message);
  } finally {
    commit("setLoading", false);
  }
}
,
    // Update supplier
    async updateSupplierAction({ commit }, { supplierId, updates }) {
      if (!supplierId || !updates) return null;
      commit("setError", null);

      try {
        const response = await axios.put(`/api/suppliers/${supplierId}`, updates);
        commit("updateSupplier", { supplierId, updates: response.data });
        return response.data;
      } catch (err) {
        const message = err?.response?.data?.message || err.message || "Failed to update supplier";
        commit("setError", message);
        throw new Error(message);
      }
    },

    // Delete supplier
    async deleteSupplier({ commit }, supplierId) {
      if (!supplierId) return null;
      commit("setError", null);

      try {
        await axios.delete(`/api/suppliers/${supplierId}`);
        commit("removeSupplier", supplierId);
        return true;
      } catch (err) {
        const message = err?.response?.data?.message || err.message || "Failed to delete supplier";
        commit("setError", message);
        throw new Error(message);
      }
    },
  },
};
